import React from "react";

const HeroCover = () => {
  return (
    <section id="home" className="relative w-full h-[75vh] overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url("/assets/pisu-cover2.png")' }}
      ></div>
      <div className="absolute inset-0 bg-black/20 backdrop-filter"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-6 max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white leading-tight mb-4">
          Savor Every Bite
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-xl mx-auto">
          Indulge in our premium handmade desserts, crafted with love and the finest ingredients
        </p>
        <div>
          <a
            href="#products"
            className="bg-white/30 hover:bg-white/40 text-white font-medium px-6 py-3 rounded-lg backdrop-blur-md transition"
          >
            Explore Our Collection
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroCover;
